/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'
import { RcmTable } from '~/components/rcm-table/RcmTable'
import { TableHeadRow, TableRow, TableHeadCell } from '~/components/table/TableComponents'
import TableDateTimeCell from '~/components/shared/TableDateTimeCell'
import { useTranslation } from 'react-i18next'
import TableMenu from './TableMenu'
import { formatUserDateTime } from '~/utils/dateFormatting'

interface ActivityRow {
  id?: number
  createdAt?: string | number
  createdById?: number
  createdByName?: string
  action?: string
  itemText?: string
  itemId?: number
  detail?: string
}

const UserActivityTable: React.FC = () => {
  const { t: translate } = useTranslation()

  return (
    <RcmTable
      className="chita-table"
      noResultsText={translate('NO_RESULTS_FILTERED')}
      disableOnInitLoad={false}
      simplePaginate={true}
      HeadRow={
        <TableHeadRow>
          <TableHeadCell sort={'createdAt'}>{translate('REPORTS_TABLE_TH_DATETIME')}</TableHeadCell>
          <TableHeadCell sort={'createdById'}>{translate('REPORTS_TABLE_TH_USER')}</TableHeadCell>
          <TableHeadCell>{translate('REPORTS_TABLE_TH_ACTION')}</TableHeadCell>
          <TableHeadCell>{translate('REPORTS_TABLE_TH_ITEM')}</TableHeadCell>
          <TableHeadCell className="actions">{translate('TASKS_TABLE_HEADER_ACTIONS')}</TableHeadCell>
        </TableHeadRow>
      }
      Row={(props: { row: ActivityRow }) => {
        const row = props.row
        return (
          <TableRow {...props}>
            <td style={{ width: 220 }}>
              {/* <TableDateTimeCell val={row.createdAt} /> */}
              {row.createdAt ? formatUserDateTime(row.createdAt) : translate('NOT_AVAILABLE')}
            </td>
            <td>{row?.createdByName ?? translate('NOT_AVAILABLE')}</td>
            <td>{row.action}</td>
            <td>
              {row.itemId ? (
                <div
                  style={{
                    height: 15,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: 700
                  }}
                >
                  {/* <a href="#" title={row.itemText}> */}
                  {row.itemText}
                  {/* </a> */}
                </div>
              ) : (
                <div
                  style={{
                    height: 15,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: 700
                  }}
                >
                  <span title={row?.itemText}>{row?.itemText ?? translate('NOT_AVAILABLE')}</span>
                </div>
              )}
            </td>
            <td className="actions">
              <TableMenu row={row} />
            </td>
          </TableRow>
        )
      }}
    />
  )
}

export default UserActivityTable
